import Contextmenu from './src/contextmenu.vue'
export default Contextmenu
